import { BulkOrderList } from "./Order.list";

const resource = {
    list: BulkOrderList
}

export default resource